<template>
  <CRow class="mb-3">
    <CCol sm="4">
      <div class="stat-card stat-card--success">
        <div class="stat-card__value">{{ ativas }}</div>
        <div class="stat-card__label">Ativas</div>
      </div>
    </CCol>
    <CCol sm="4">
      <div class="stat-card stat-card--warning">
        <div class="stat-card__value">{{ agendadas }}</div>
        <div class="stat-card__label">Agendadas</div>
      </div>
    </CCol>
    <CCol sm="4">
      <div class="stat-card stat-card--danger">
        <div class="stat-card__value">{{ encerrando }}</div>
        <div class="stat-card__label">Encerrando em 7 dias</div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import { computeStatus, STATUS } from "../helpers/campanhaStatus";
import { isEncerrandoEmDias } from "../helpers/campanhaStatus";

export default {
  name: "CampanhaStatsRow",
  props: {
    campanhas: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ativas() {
      return this.campanhas.filter(
        (c) => computeStatus(c) === STATUS.ATIVA
      ).length;
    },
    agendadas() {
      return this.campanhas.filter(
        (c) => computeStatus(c) === STATUS.AGENDADA
      ).length;
    },
    encerrando() {
      return this.campanhas.filter((c) => isEncerrandoEmDias(c, 7)).length;
    },
  },
};
</script>

<style scoped>
.stat-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
}

.stat-card--success {
  border-left: 4px solid #5eb95e;
}

.stat-card--warning {
  border-left: 4px solid #f37b1d;
}

.stat-card--danger {
  border-left: 4px solid #d9534f;
}

.stat-card__value {
  font-size: 24px;
  font-weight: 700;
  color: #2c2c2c;
}

.stat-card__label {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}
</style>
